import React, { useState, useEffect } from 'react'

import {
  Grid, Card, CardHeader, CardContent, Typography,
  Button, ButtonGroup, FilledInput, InputAdornment
} from '@material-ui/core'

import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import GetAppIcon from '@material-ui/icons/GetApp'
import BorderColorIcon from '@material-ui/icons/BorderColor'
import PublishIcon from '@material-ui/icons/Publish'

import { makeStyles } from '@material-ui/core/styles'

import { useSelector } from 'react-redux'
import { getTemplate } from '../../../../utils'

const useStyles = makeStyles(theme => ({
  uploadContainer: {
    height: '100%',
    minHeight: '40em'
  },
  uploadItem: {
    marginTop: 'auto',
    marginBottom: 'auto',
    height: 'auto'
  },
  uploadCard: {
    width: '85%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  uploadBtnGroup: {
    width: '100%'
  },
  uploadBtn: {
    width: '50%',
    backgroundColor: '#3984f7',
    color: '#fff',
    paddingTop: '2.5em',
    paddingBottom: '2.5em',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  insertBtn: {
    width: '50%',
    backgroundColor: '#8BB84B',
    color: '#fff',
    paddingTop: '2.5em',
    paddingBottom: '2.5em',
    '&:hover': {
      backgroundColor: '#588518'
    }
  },
  helpItem: {
    marginBottom: 'auto'
  },
  helpCard: {
    width: '55%',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  downloadBtn: {
    backgroundColor: '#8BB84B',
    color: '#fff',
    paddingTop: '1em',
    paddingBottom: '1em',
    '&:hover': {
      backgroundColor: '#588518',
      color: '#fff'
    }
  },
  batchItem: {
    height: 'auto'
  },
  uploadInput: {
    display: 'none'
  },
  imageNameAvatar: {
    background: theme.palette.action.selected,
    '&:hover': {
      background: theme.palette.background.default
    },
    '&.Mui-focused': {
      background: theme.palette.background.default
    }
  },
  disabledText: {
    color: '#aba9a9',
    fontWeight: 600
  }
}))

const UserMgmtBatchUpload = (props) => {
  const { onBackBatchUpload, onUploadCSV, btnStats, onBatchUploadCSV, fileName, onBatchUploadData } = props

  const classes = useStyles()

  const [link, setLink] = useState('')

  const { token, accountId } = useSelector(state => state.auth)

  useEffect(() => {
    if (token && accountId) {
      const getBlob = async () => {
        const downloadBlob = async () => {
          const blob = await getTemplate(token, accountId)
          return blob
        }

        const blob = await downloadBlob()
        setLink(blob)
      }
      getBlob()
    }
  }, [token, accountId])

  return (
    <>
      <Grid container direction='column' className={classes.uploadContainer}>
        <Grid item className={`w-100 ${classes.batchItem}`}>
          <button type='button' className='btn green-button ' onClick={onBackBatchUpload}>Back</button>
          <h2 className='my-2'>Batch Upload</h2>
        </Grid>
        <Grid item className={`w-100 ${classes.uploadItem}`}>
          <Card className={classes.uploadCard}>
            <CardHeader
              title='Upload a CSV File or Enter Data Manually'
              className='pb-0 text-center'
            />
            <CardContent>
              <Grid container direction='row'>
                <Grid item container direction='column' spacing={2}>

                  <Grid container item direction='row' className='pt-0'>
                    <ButtonGroup className={classes.uploadBtnGroup}>
                      <Button
                        variant='contained'
                        className={classes.uploadBtn}
                        disabled={btnStats.csvUploadStat}
                        onClick={onBatchUploadCSV}
                      >
                        <Typography variant='h6' component='h6'>
                          <CloudUploadIcon fontSize='large' /> Upload CSV File
                        </Typography>
                      </Button>
                      <Button variant='contained' className={classes.insertBtn} onClick={onBatchUploadData}>
                        <BorderColorIcon fontSize='large' />
                        <Typography variant='h6' component='h6' className='w-50 flex-wrap'>
                          Insert Data Manually
                        </Typography>
                      </Button>
                    </ButtonGroup>
                  </Grid>

                  <Grid container item direction='row' className=''>
                    <input
                      className={classes.uploadInput}
                      type='file'
                      id='customFile'
                      onChange={onUploadCSV}
                      accept='text/csv'
                    />
                    <label htmlFor='customFile' className='w-100'>
                      <FilledInput
                        value={fileName}
                        className={classes.imageNameAvatar}
                        fullWidth
                        readOnly
                        endAdornment={
                          <InputAdornment position='end'>
                            <Button variant='contained' color='primary' component='span' className={classes.button}>
                              <PublishIcon />
                            </Button>
                          </InputAdornment>
                        }
                      />
                    </label>
                  </Grid>
                </Grid>

                <Grid item container direction='column' justify='center' alignItems='center'>
                  <Typography variant='caption' className={classes.disabledText} style={{ marginTop: '0.6em' }}>* Must include first name, last name, job title, office phone, and email address as headers. </Typography>
                </Grid>

              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item className={`w-100 ${classes.helpItem}`}>
          <Card className={classes.helpCard}>
            <CardHeader
              title={(
                <Typography variant='h6' component='h6' className='text-center'>
                  Need help getting started?
                </Typography>
              )}
              className='pb-0'
            />
            <CardContent>
              <Grid container direction='row' justify='center'>
                <Button
                  variant='contained'
                  className={classes.downloadBtn}
                  component='a'
                  disabled={link === ''}
                  href={link}
                  target='_blank'
                  rel='noopener noreferrer'
                  download='template.csv'
                >
                  <Typography>
                    <GetAppIcon /> Download Template
                  </Typography>
                </Button>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

export default UserMgmtBatchUpload
